import { defineStore } from 'pinia';
import dayjs from 'dayjs';

export interface NoticeData {
  parcelImageUrl: string;
  parcelImageLink: string;
  quickImageUrl: string;
  quickImageLink: string;
  mailImageUrl: string;
  mailImageLink: string;
  globalImageUrl: string;
  globalImageLink: string;
}

interface IsShowToday {
  [key: string]: string;
  quick: string;
  parcel: string;
  registry: string;
  global: string;
}

interface NoticeState {
  notice: NoticeData;
  isOpen: boolean;
  isShowToday: IsShowToday;
}

const initialNotice = (): NoticeData => ({
  parcelImageUrl: '',
  parcelImageLink: '',
  quickImageUrl: '',
  quickImageLink: '',
  mailImageUrl: '',
  mailImageLink: '',
  globalImageUrl: '',
  globalImageLink: '',
});

const initialIsShowToday = (): IsShowToday => ({
  quick: dayjs().format('YYYY-MM-DD'),
  parcel: dayjs().format('YYYY-MM-DD'),
  registry: dayjs().format('YYYY-MM-DD'),
  global: dayjs().format('YYYY-MM-DD'),
});

export const useNoticePopupStore = defineStore('noticePopup', {
  state: (): NoticeState => ({
    notice: initialNotice(),
    isOpen: false,
    isShowToday: initialIsShowToday(),
  }),

  actions: {
    updateNotice(payload: NoticeData) {
      this.notice.parcelImageUrl = payload.parcelImageUrl || '';
      this.notice.parcelImageLink = payload.parcelImageLink || '';
      this.notice.quickImageUrl = payload.quickImageUrl || '';
      this.notice.quickImageLink = payload.quickImageLink || '';
      this.notice.mailImageUrl = payload.mailImageUrl || '';
      this.notice.mailImageLink = payload.mailImageLink || '';
      this.notice.globalImageUrl = payload.globalImageUrl || '';
      this.notice.globalImageLink = payload.globalImageLink || '';
    },
    updateIsNoticeOpen(payload: boolean) {
      this.isOpen = payload;
    },
  },
});
